/**
 * 'App Router'
 * the application router
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */
import AppView from '@/views/app/app.view'
import HomeRoute from './home/home.route'
import ReadEventRoute from './events/read-events.route'
import ReadArtistRoute from './artist/read-artist.router'
import SearchRoute from './search-page/search-page.router'
import FaqRoute from './faq/faq.router'
import UserProfileRoute from './user-profile/user-profile.route'
import PointSaleRouter from './point-of-sale/point-of-sale'
export default [{
  path: '',
  name: '',
  component: AppView,
  meta: {
    breadcrumb: 'Home',
    title: 'Hi!',
    top: 75
  },
  children: [
    ...HomeRoute,
    ...ReadEventRoute,
    ...ReadArtistRoute,
    ...SearchRoute,
    ...FaqRoute,
    ...UserProfileRoute,
    ...PointSaleRouter
  ]
}]



// WEBPACK FOOTER //
// ./src/router/routes/app/app.router.js